import React from 'react';
import { Layout } from '../components/Layout/Layout';
import { MessageTemplates } from '../components/Advisor/MessageTemplates';

export const AdvisorTemplatesPage: React.FC = () => {
  return (
    <Layout>
      <div className="p-6">
        <MessageTemplates />
      </div>
    </Layout>
  );
};